export default "__VITE_ASSET__Dx5sNri5__"